// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Belt_MapString from "rescript/lib/es6/belt_MapString.js";
import * as UserContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/UserContext.res.mjs";
import * as MatrixTypes$LiteracyplanetClientSxEntry from "./MatrixTypes.res.mjs";
import * as AcademyMatrixQueries$LiteracyplanetClientSxEntry from "./AcademyMatrixQueries.res.mjs";

function useMap(category, fetchAgg, $$default) {
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var match = React.useState(function () {
        
      });
  var setMatrix = match[1];
  var matrix = match[0];
  var mergeMatrix = function (m) {
    setMatrix(function (matrix) {
          return Belt_MapString.reduce(m, matrix, Belt_MapString.set);
        });
  };
  var queryMatrix = async function (category) {
    Belt_Option.map(await fetchAgg(category), mergeMatrix);
  };
  React.useEffect((function () {
          if (category !== undefined) {
            queryMatrix(category);
          }
          
        }), [category]);
  var onGetMatrix = function (id) {
    return Belt_Option.getWithDefault(Belt_MapString.get(matrix, MatrixTypes$LiteracyplanetClientSxEntry.makeMatrixKey(userId, id)), $$default);
  };
  return [
          onGetMatrix,
          queryMatrix
        ];
}

function useActivities(md5Opt, name, category) {
  var md5 = md5Opt !== undefined ? Caml_option.valFromOption(md5Opt) : undefined;
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var fetchAgg = AcademyMatrixQueries$LiteracyplanetClientSxEntry.useActivities(userId);
  return useMap(category, (function (category) {
                return fetchAgg(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(md5), Caml_option.some(name), category);
              }), "LoadingActivityAgg");
}

function useMenu(md5, name, category) {
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var fetchAgg = AcademyMatrixQueries$LiteracyplanetClientSxEntry.useCategories(userId);
  return useMap(category, (function (category) {
                return fetchAgg(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(md5), Caml_option.some(name), category);
              }), {
              loading: true,
              totalActivityCount: 0
            });
}

export {
  useMap ,
  useActivities ,
  useMenu ,
}
/* react Not a pure module */
